var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.small ? 'small' : ''},[_c('div',{staticClass:"badge"},[_c('LogoSvg',{staticClass:"logo"}),_c('div',{staticClass:"badge-name"},[_vm._v("AMBASSADOR")]),_c('div',{staticClass:"hashtag"},[_vm._v("#explore_and_earn")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }